export default {
  install (Vue) {
    Vue.prototype.$hasPermission = function (permission) {
      const permissions = this.$store.getters['auth/user/userPermissions'] || []
      return permissions.includes(permission)
    }
    Vue.prototype.$hasFeatureFlag = function (flag) {
      const flags = this.$store.getters['auth/user/featureFlags'] || []
      return flags.includes(flag)
    }
  },
}
